<template>
  <div>
    <v-container class="container--fluid">
      <StringboxFarmCompariton :stringdata="stringdata" />
    </v-container>
  </div>
</template>

<script>
import StringboxFarmCompariton from "@/views/components/Stringbox/StringboxFarmCompariton.vue";
import { getStringboxList } from "@/api/Request/stringbox";
import helper from "@/api/helper";

export default {
  components: {
    StringboxFarmCompariton,
  },
  props: ["farmdata"],
  data() {
    return {
      stringdata: {},
    };
  },
  computed: {},
  watch: {
    farmdata: {
      handler() {
        this.selectedStringbox();
      },
      deep: true,
    },
  },

  mounted() {
    if (Object.keys(this.farmdata).length > 0) {
      this.selectedStringbox();
    }
  },
  methods: {
    selectedStringbox() {
      const payload = {
        condiniton: {
          prefix: this.farmdata.prefix,
          companyCode: this.farmdata.companyCode,
        },
      };

      this.getStringboxData(payload);
    },
    getStringboxData(payload) {
      const windowsWidth = document.documentElement.clientWidth - 270;
      getStringboxList(payload).then((res) => {
        if (res.data.success === "true") {
          if (!helper.is_Empty(res.data.data)) {
            // context.commit('SET_INVERTERDATA', res.data.data);
            const temp = {};
            const tempMeasures = [];
            const measuresList = [];
            const santralList = [];
            // eslint-disable-next-line no-underscore-dangle
            const _t = ["sum", "avg", "1"];
            Object.keys(res.data.data).forEach((i) => {
              const {
                santral,
                STRINGBOX,
                // eslint-disable-next-line camelcase
                general_measure_list,
              } = res.data.data[i];
              if (santralList.indexOf(santral) === -1) {
                santralList.push(santral);
              }
              if (!helper.is_Empty(STRINGBOX)) {
                if (helper.is_Empty(temp[santral])) {
                  temp[santral] = {};
                }
                if (helper.is_Empty(temp[santral][STRINGBOX])) {
                  temp[santral][STRINGBOX] = {};
                }
                temp[santral][STRINGBOX] = res.data.data[i];
                Object.keys(general_measure_list).forEach((i) => {
                  if (
                    measuresList.indexOf(general_measure_list[i].value) ===
                      -1 &&
                    _t.indexOf(general_measure_list[i].formuletype) > -1
                  ) {
                    tempMeasures.push(general_measure_list[i]);
                    measuresList.push(general_measure_list[i].value);
                  }
                });
              }
            });
            this.stringdata = {
              measures: tempMeasures,
              santralStringboxData: temp,
              santralList,
              prefix: this.farmdata.prefix,
              companyCode: this.farmdata.companyCode,
              windowsWidth,
            };
          }
        }
      });
    },
  },
};
</script>
